import { returnSendEmailRecoveryPasswordErrorType } from 'services/returnApiType'
import {IRegisterSuscriptionProps} from './registerSubscription.d'
import { alphanumericFormatter, numberFormatter, textFormatter } from 'utils/functions/formatString'
import { isCuil, isValidCuil, isValidEmail } from 'utils/functions/validations'
import { STATUS_SUCCESS } from 'services/apiData'
import { postValidatePassword } from 'services/api'

export const COUNTRY_ARGENTINA = 'Argentina'
export const CODAREA_ARGENTINA = 'AR'
export const cuilDigitsLength = 11
export const documentForeignType = 'Documento Extranjero'
export const documentCuilType = 'cuil' 
export const number14 = 14

export const documentTypes = [
  { id: 1, type: 'Documento Extranjero' },
  { id: 2, type: 'Pasaporte' },
]

const number6 = 6

// TODO: puede reducirse a... const maxLengthcodArea = (): number => (14 - (phoneLength + countryPhoneCodeLength))
export const maxLengthcodAreaData = (phoneLength: number, countryPhoneCodeLength: number, countryCodAreaLength: number): number => {
    if ((phoneLength === 10 && countryPhoneCodeLength === 3) || (phoneLength === 9 && countryPhoneCodeLength === 4)) {
      return 1
    }
    if ((phoneLength === 10 && countryPhoneCodeLength === 2) || (phoneLength === 9 && countryPhoneCodeLength === 3) || (phoneLength === 8 && countryPhoneCodeLength === 4)) {
      return 2
    }
    if ((phoneLength === 9 && countryPhoneCodeLength === 2) || (phoneLength === 8 && countryPhoneCodeLength === 3) || (phoneLength === 7 && countryPhoneCodeLength === 4)) {
      return 3
    }
    // Si countryPhoneCodeLength es 3 y countryCodAreaLength es 4, devuelve 4, asegurando que no supere los 14 caracteres
    if (countryPhoneCodeLength === 3 && countryCodAreaLength === 4) {
      return 4
    }
    // Si no se cumple ninguna de las condiciones anteriores, devuelve 4 para garantizar un máximo de 14 caracteres
    return 4
  }

// TODO: Se puede reducir a... const maxLengthNumber = (): number => (14 - (countryPhoneCodeLength + countryCodAreaLength))
export const maxLengthNumberData = (countryPhoneCodeLength: number, countryCodAreaLength: number): number => {
    if (countryPhoneCodeLength === 2 && countryCodAreaLength === 2) {
      return 10
    }
    if ((countryPhoneCodeLength === 2 && countryCodAreaLength === 3) || (countryPhoneCodeLength === 3 && countryCodAreaLength === 2) || (countryPhoneCodeLength === 4 && countryCodAreaLength === 1)) {
      return 9
    }
    if (countryPhoneCodeLength === 3 && countryCodAreaLength === 4) {
      return 7
    }
    if ((countryPhoneCodeLength === 3 && countryCodAreaLength === 3) || (countryPhoneCodeLength === 2 && countryCodAreaLength === 4) || (countryPhoneCodeLength === 4 && countryCodAreaLength === 2)) {
      return 8
    }
    if (countryPhoneCodeLength === 4 && countryCodAreaLength === 4) {
      return 6
    }
    if ((countryPhoneCodeLength === 4 && countryCodAreaLength === 3) || (countryPhoneCodeLength === 3 && countryCodAreaLength === 4)) {
      return 7
    }
    // Si no se cumple ninguna de las condiciones anteriores, devuelve 10 para garantizar un máximo de 14 caracteres
    return 10
  }
  
export const titleData = (dataSubscription:IRegisterSuscriptionProps) => {
    if (dataSubscription.isRecoveryUser && !dataSubscription.isNewAccount) {
      return '¡Vamos a recuperar tu usuario y contraseña!'
    }
    if (dataSubscription.isValidateIdentity) {
      return 'Vamos a validar tu identidad'
    }
    if (dataSubscription.isNewAccount) {
      return 'Vamos a validar tu identidad'
    }
    return '¡Vamos a crear tu cuenta!'
  }
  
export const subtitleData = (dataSubscription:IRegisterSuscriptionProps) => {
    if (!dataSubscription.isRecoveryUser && !dataSubscription.isNewAccount) {
      return 'Para comenzar, necesitamos algunos datos'
    }
    if (dataSubscription.isValidateIdentity) {
      return 'Completá los campos con tus datos personales'
    }
    return 'Completá los datos para continuar.'
  }

export const isSendlError = sendEmailFailErr =>      
  ( sendEmailFailErr === returnSendEmailRecoveryPasswordErrorType.errorTimesRecovery || 
    sendEmailFailErr === returnSendEmailRecoveryPasswordErrorType.errorAttempts || 
    sendEmailFailErr === returnSendEmailRecoveryPasswordErrorType.errorOperator)
  
export const isEmailSentError = sendEmailFailErr =>
  ( sendEmailFailErr === returnSendEmailRecoveryPasswordErrorType.errorSentRecently ||
    sendEmailFailErr === returnSendEmailRecoveryPasswordErrorType.errorSentExceeded)


//    
// HANDLE Events  //
//

export const handleTextFieldsChangeData = (event: React.ChangeEvent<HTMLInputElement>,handleFieldChange) => {
    const { value } = event.target
    const result: string = textFormatter(value)
    const ev = {
      target: {
        name: event.target.name,
        value: result,
      },
    }
    // prevents field change if user has entered only spaces
    if (/\S/.test(value) || value.length === 0) {
      handleFieldChange(ev)
    }
  }

export const handleNumberFieldChangeData = (event: React.ChangeEvent<HTMLInputElement>, handleFieldChange) => {
    const { value, name } = event.target
    const result: string = numberFormatter(value)
    const e = { target: { name, value: result } }
    handleFieldChange(e)
  }

export const handleEmailValidationData = (event: React.ChangeEvent<HTMLInputElement>, handleFieldError) => {
    if (!isValidEmail(event.target.value)) {
      handleFieldError(event, { message: 'El email no es válido', isInvalid: true })
    } else {
      handleFieldError(event)
    }
  }

export const handleEmailChangeData = (event: React.ChangeEvent<HTMLInputElement>,handleFieldChange,handleFieldError) => {
    const { value } = event.target
    // prevents field change if user has entered only spaces
    if (/\S/.test(value) || value.length === 0) {
      handleFieldChange(event)
    }
    if (isValidEmail(value)) {
      handleFieldError(event)
    }
  }
  
export const handleCuilValidationData = (event: React.ChangeEvent<HTMLInputElement>,handleFieldError) => {
    const { value } = event.target
    const cuilOnlyDigits = value.replace(/-/g, '')
    if (!isValidCuil(cuilOnlyDigits) || !isCuil(cuilOnlyDigits)) {
      handleFieldError(event, { message: 'El formato del CUIL no es válido', isInvalid: true })
    } else {
      handleFieldError(event)
    }
  }

export const handleDocumentForeignChangeData =(event: React.ChangeEvent<HTMLInputElement>,handleFieldChange) => {
    const { value } = event.target
    const result: string = alphanumericFormatter(value)
    const e = {
      target: {
        name: event.target.name,
        value: result,
      },
    }
    // prevents field change if user has entered only spaces
    if (/\S/.test(value) || value.length === 0) {
      handleFieldChange(e)
    }
  }

export const handleClaveValidationData = async (event: React.ChangeEvent<HTMLInputElement>,handleFieldError) => {
    const { value } = event.target
    if (value.length === 0) {
      handleFieldError(event, { message: 'Campo requerido', isInvalid: true })
      return
    }
    if (value.length < number6) {
      handleFieldError(event, { message: 'La clave es inválida', isInvalid: true })
      return
    }
    const { data, status } = await postValidatePassword(value)
    if (status === STATUS_SUCCESS) {
      handleFieldError(event, { message: data.message, isInvalid: true })
    } else {
      handleFieldError(event)
    }
  }
  
export const handleFieldValidationData = async (event: React.ChangeEvent<HTMLInputElement>,handleFieldError,validateNumber) => {
    const { value } = event.target
    if (value.trim() === '') {
      handleFieldError(event, { message: 'Este campo es requerido', isInvalid: true })
    } else if (event.target.name === 'codArea' || event.target.name === 'phone' || event.target.name === 'areaCodePhone') {
      validateNumber(event)
    } else {
      handleFieldError(event)
    }
  }
  